const offers = [
  {
    id: 8,
    name: "One month’s FREE Accountancy Services",
    info: "Get a <strong>whole month FREE</strong> at Simplify Accountancy, who help self-employed professionals to work compliantly and tax efficiently. Gain unlimited access...",
    logo: "/images/offers-images/logos/simplify-logo.png",
    backgroundImg: "/images/offers-images/backgrounds/simplify-background.png",
    imgAlt: "Simplify",

    overlayId: 8,
    overlayText:
      "Get a <strong>FREE month</strong> at Simplify Accountancy, who help self-employed professionals to <strong>work compliantly and tax efficiently</strong>. Gain <strong>unlimited</strong> access to your own fully qualified accountant, who will handle all of your accountancy needs. Including access to your own FreeAgent subscription so you can <strong>keep track of your finances</strong>.",
    overlayLinkName: "1 month’s FREE Services",
    overlayOfferLink:
      "https://simplifyaccountancy.com/ola/services/free-consultation-call",
  },
  {
    id: 6,
    name: "FREE no obligation IT System Health Check",
    info: "<strong>Single Point of Service</strong> is our unique approach to delivering outsourced IT Services to our customers across the UK. We provide a comprehensive range of IT Services & Solutions...",
    logo: "/images/offers-images/logos/greenlight-computers-logo.jpg",
    backgroundImg:
      "/images/offers-images/backgrounds/greenlight-computers-background.jpg",
    imgAlt: "Greenlight Computers",

    overlayId: 6,
    overlayText:
      "<strong>Single Point of Service</strong> is our unique approach to delivering outsourced IT Services to our customers across the UK. We provide a comprehensive range of IT Services & Solutions through an experienced and professional team of specialist technicians. <strong>We are a trusted partner to our clients.</strong>",
    overlayLinkName: "FREE IT System Health Check",
    overlayOfferLink:
      "https://www.greenlightcomputers.co.uk/?utm_source=SITE&utm_medium=community&utm_campaign=HiringHubAgencyOffersPage&utm_term=",
  },
  {
    id: 7,
    name: "20% off telephony costs for the first 3 months",
    info: "Cloud based VOIP Telephony Solutions from <strong>Greenlight Telecoms</strong> are cost efficient with leading edge features to help you get the best from your business communications!",
    logo: "/images/offers-images/logos/greenlight-telecoms-logo.jpg",
    backgroundImg:
      "/images/offers-images/backgrounds/greenlight-telecoms-background.jpg",
    imgAlt: "Greenlight Telecoms",

    overlayId: 7,
    overlayText:
      "Cloud based VOIP Telephony Solutions from <strong>Greenlight Telecoms</strong> are cost efficient with leading edge features to help you get the best from your business communications! Packages available from as little as £13.00 per line with a shiny new Cisco phone included. <strong>Special bundles available on request.</strong>",
    overlayLinkName: "20% off telephony costs",
    overlayOfferLink:
      "https://www.greenlightcomputers.co.uk/unified-communications/?utm_source=SITE&utm_medium=community&utm_campaign=HiringHubAgencyOffersPage&utm_term=",
  },
  {
    id: 1,
    name: "Receive £960 of free content and SEO services",
    info: 'Receive £960 of free content and SEO services when quoting <strong><i>"Hiring Hub"</i></strong>. Websites are GDPR and Google for Job compliant with state-of-the-art recruitment features reliability...',
    logo: "/images/offers-images/logos/recruiterweb-logo.png",
    backgroundImg:
      "/images/offers-images/backgrounds/recruiterweb-background.png",
    imgAlt: "Recruitment Website",

    overlayId: 1,
    overlayText:
      "Receive £960 of free content and SEO services when quoting <strong>Hiring Hub</strong>. Websites are GDPR and Google for Job compliant with state-of-the-art recruitment features reliability. Prices start at £150 per month on a SaaS basis.",
    overlayLinkName: "£960 FREE",
    overlayOfferLink: "https://www.recruiterweb.co.uk/",
  },
  {
    id: 2,
    name: "Get up to 28% off Apple Macbooks",
    info: "Buy official, Apple-certified refurbished MacBooks and MacBook Pros.<br><br>All with full Apple one-year warranty, and <strong>save up to 28%</strong>.",
    logo: "/images/offers-images/logos/utopia-logo.png",
    backgroundImg: "/images/offers-images/backgrounds/utopia-background.png",
    imgAlt: "Apple MacBook – Save up to 28%",

    overlayId: 2,
    overlayText:
      "Buy official, Apple-certified refurbished MacBooks and MacBook Pros, all with full Apple one-year warranty, and <strong>save up to 28%</strong>.",
    overlayLinkName: "28% discount",
    overlayOfferLink: "https://store.utopiatechnology.co.uk/",
  },
  {
    id: 3,
    name: "Discounted back-office support",
    info: "Gain access to an agile SME pricing model exclusively with <strong>Tifo Comply</strong>, a candidate on-boarding platform, with an integrated checking service and Tifo Timesheets...",
    logo: "/images/offers-images/logos/tifo-logo.png",
    backgroundImg: "/images/offers-images/backgrounds/tifo-background.jpg",
    imgAlt: "Tifo",

    overlayId: 3,
    overlayText:
      "Gain access to an agile SME pricing model exclusively with <strong>Tifo Comply</strong>, a candidate on-boarding platform, with an integrated checking service and Tifo Timesheets, a platform used to log contractor activity for accurate and easy approval.",
    overlayLinkName: "Exclusive price",
    overlayOfferLink:
      "http://tifo.team/?utm_source=&amp;banner&amp;utm_medium=Hiring_hub&amp;utm_campaign=partnership",
  },
  {
    id: 4,
    name: "10% discount on advanced contract placement funding",
    info: "Gain access to an agile pricing model exclusively for Hiring Hub subscribers plus a further <strong>10% discount</strong> on 1PS’s advanced contract placement funding...",
    logo: "/images/offers-images/logos/1ps-logo.png",
    backgroundImg: "/images/offers-images/backgrounds/1ps-background.png",
    imgAlt: "1PS",

    overlayId: 4,
    overlayText:
      "Gain access to an agile pricing model exclusively for Hiring Hub Subscribers plus a further <strong>10% discount</strong> on 1PS’s advanced contract placement funding. 1PS provide 100% advance funding, giving agencies hassle free, easy cash flow management by paying the contractors and the agency margin in advance.",
    overlayLinkName: "10% discount",
    overlayOfferLink: "https://my1ps.com/why-1ps-2/",
  },
  {
    id: 5,
    name: "Contractor Accountancy service provider",
    info: "<strong>PayStream</strong> provide a full suite of contractor payroll and accountancy services including limited company, umbrella and CIS that cater for all your contractors regardless of their industry or circumstances.",
    logo: "/images/offers-images/logos/paystream-logo.png",
    backgroundImg: "/images/offers-images/backgrounds/paystream-background.jpg",
    imgAlt: "PayStream",

    overlayId: 5,
    overlayText:
      "<strong>PayStream</strong> provide a full suite of contractor payroll and accountancy services including limited company, umbrella and CIS that cater for all your contractors regardless of their industry or circumstances.",
    overlayLinkName: "Learn more",
    overlayOfferLink:
      "https://www.paystream.co.uk/?utm_source=&amp;banner&amp;utm_medium=Hiring_hub&amp;utm_campaign=partnership",
  },
];

export default offers;
